/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderLineOptionDto } from './OrderLineOptionDto';
import {
    OrderLineOptionDtoFromJSON,
    OrderLineOptionDtoFromJSONTyped,
    OrderLineOptionDtoToJSON,
} from './OrderLineOptionDto';

/**
 * 
 * @export
 * @interface OrderLineDto
 */
export interface OrderLineDto {
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    itemVariantId: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    takeawayPrice?: number;
    /**
     * 
     * @type {Array<OrderLineOptionDto>}
     * @memberof OrderLineDto
     */
    options: Array<OrderLineOptionDto>;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    totalPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    totalTakeawayPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    menuSectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    sectionProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderLineDto
     */
    openPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    courseId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    giftCardId?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLineDto
     */
    unitQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderLineDto
     */
    compositeProductId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderLineDto
     */
    isCompositeProduct: boolean;
    /**
     * 
     * @type {Array<OrderLineDto>}
     * @memberof OrderLineDto
     */
    components?: Array<OrderLineDto>;
}

/**
 * Check if a given object implements the OrderLineDto interface.
 */
export function instanceOfOrderLineDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "itemVariantId" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "options" in value;
    isInstance = isInstance && "totalPrice" in value;
    isInstance = isInstance && "isCompositeProduct" in value;

    return isInstance;
}

export function OrderLineDtoFromJSON(json: any): OrderLineDto {
    return OrderLineDtoFromJSONTyped(json, false);
}

export function OrderLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderLineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'quantity': json['quantity'],
        'itemVariantId': json['itemVariantId'],
        'price': json['price'],
        'takeawayPrice': !exists(json, 'takeawayPrice') ? undefined : json['takeawayPrice'],
        'options': ((json['options'] as Array<any>).map(OrderLineOptionDtoFromJSON)),
        'totalPrice': json['totalPrice'],
        'totalTakeawayPrice': !exists(json, 'totalTakeawayPrice') ? undefined : json['totalTakeawayPrice'],
        'menuSectionId': !exists(json, 'menuSectionId') ? undefined : json['menuSectionId'],
        'sectionProductId': !exists(json, 'sectionProductId') ? undefined : json['sectionProductId'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'openPrice': !exists(json, 'openPrice') ? undefined : json['openPrice'],
        'courseId': !exists(json, 'courseId') ? undefined : json['courseId'],
        'giftCardId': !exists(json, 'giftCardId') ? undefined : json['giftCardId'],
        'unitQuantity': !exists(json, 'unitQuantity') ? undefined : json['unitQuantity'],
        'compositeProductId': !exists(json, 'compositeProductId') ? undefined : json['compositeProductId'],
        'isCompositeProduct': json['isCompositeProduct'],
        'components': !exists(json, 'components') ? undefined : ((json['components'] as Array<any>).map(OrderLineDtoFromJSON)),
    };
}

export function OrderLineDtoToJSON(value?: OrderLineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'quantity': value.quantity,
        'itemVariantId': value.itemVariantId,
        'price': value.price,
        'takeawayPrice': value.takeawayPrice,
        'options': ((value.options as Array<any>).map(OrderLineOptionDtoToJSON)),
        'totalPrice': value.totalPrice,
        'totalTakeawayPrice': value.totalTakeawayPrice,
        'menuSectionId': value.menuSectionId,
        'sectionProductId': value.sectionProductId,
        'comment': value.comment,
        'openPrice': value.openPrice,
        'courseId': value.courseId,
        'giftCardId': value.giftCardId,
        'unitQuantity': value.unitQuantity,
        'compositeProductId': value.compositeProductId,
        'isCompositeProduct': value.isCompositeProduct,
        'components': value.components === undefined ? undefined : ((value.components as Array<any>).map(OrderLineDtoToJSON)),
    };
}

